import { Link } from "react-router-dom";
import { useClassrooms } from "../data/ClassroomContext";
import { ASSIGNMENT_STATUS, purposeLabel } from "../data/assignments";
import { useAssignments } from "../data/useClassroomWorkspace";
import WorkspaceStatus from "../components/WorkspaceStatus";
import { formatWhen } from "../components/WorkState";
import ui from "../components/ui.module.css";

// Homework, practice and tests set for the class, newest first. Each opens to
// its learners' progress. Finished work still arrives in "Work to review";
// this is not a second queue.
export const AssignmentList = () => {
  const { active } = useClassrooms();
  const assignments = useAssignments(active.id);
  const items = assignments.data || [];
  return (
    <section className={ui.stack} aria-labelledby="assignments-title">
      <h2 id="assignments-title" className={ui.cardTitle}>Homework and tests</h2>
      <WorkspaceStatus resource={assignments} loadingLabel="Loading homework and tests…" className={active.name} />
      {assignments.data &&
        (items.length ? (
          <ul className={ui.list}>
            {items.map((item) => (
              <li key={item.id} className={`${ui.card} ${ui.workItem}`}>
                <div className={ui.stack} style={{ gap: "0.25rem" }}>
                  <p className={ui.cardTitle}>{item.title || "Learner activity"}</p>
                  <p className={ui.meta}>
                    {[
                      purposeLabel(item.purpose),
                      item.audience === "selected_learners" ? "Some learners" : "Whole class",
                      item.dueAt && `Due ${formatWhen(item.dueAt)}`,
                      ASSIGNMENT_STATUS[item.status],
                    ]
                      .filter(Boolean)
                      .join(" · ")}
                  </p>
                </div>
                <Link
                  to={`/work/assignments/${item.id}`}
                  className={`${ui.button} ${ui.secondary}`}
                  aria-label={`Progress: ${item.title || purposeLabel(item.purpose)}`}
                >
                  Progress
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className={ui.meta}>
            Nothing set yet. To set homework or a test, open a lesson and choose “Set work for later”.
          </p>
        ))}
    </section>
  );
};

export default AssignmentList;
